import { jsx as _jsx } from "react/jsx-runtime";
import { checkIsAbsolute } from '~/utils/helpers';
import { Link } from './obituaryLink.styles';
const ObituaryLink = ({ link }) => {
    return (_jsx(Link, { id: "obituaryBtn", href: checkIsAbsolute(link) ? link : `//${link}`, target: "_blank", rel: "noreferrer", children: "Obituary Page" }));
};
export default ObituaryLink;
